import { Dialog } from 'primereact/dialog';
import { Steps } from 'primereact/steps';
import { useState } from 'react';
import { IPurchaseOrder } from '../../../models/PurchaseOrder';
import { Button } from 'primereact/button';
import { IncentiveCalculation } from './IncentiveCalculation';
import { ProjectInformation } from './ProjectInformation';
import { SubVendorInformation } from './SubVendorInformation';
import { ClientInformation } from './ClientInformation';
import { ConsultantInformation } from './ConsultantInformation';
import { PositionInformation } from './PositionInformation';
import { BranchIncentiveCalculation } from './BranchIncentiveCalculation';

interface Iprops {
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void,
    po: IPurchaseOrder
}

export const Details = (props: Iprops) => {
    const [activeIndex, setActiveIndex] = useState(0);
    const [needtoReload, setNeedtoReload] = useState(false);

    const interactiveItems = [
        { label: 'Position Information' },
        { label: 'Consultant Information' },
        { label: 'Client Information' },
        { label: 'Sub Vendor Information' },
        { label: 'Project Information' },
        { label: 'Incentive Calculation' },
        // { label: 'Branch Share Percentage' }
    ];

    function onHide() {
        props.hideDialog();
        setActiveIndex(0);
        if (needtoReload) { props.setReload(!props.reload); setNeedtoReload(false); }
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Edit Purchase Order" className="p-fluid" onHide={onHide}>
            <Steps className='mt-1 mb-2' model={interactiveItems} activeIndex={activeIndex} onSelect={(e) => setActiveIndex(e.index)} readOnly={true} />
            <hr style={{ border: "1px solid #6699CC" }} />
            {activeIndex === 0 && <PositionInformation setNeedtoReload={setNeedtoReload} activeIndex={activeIndex} setActiveIndex={setActiveIndex} po={props.po} toast={props.toast} />}
            {activeIndex === 1 && <ConsultantInformation setNeedtoReload={setNeedtoReload} activeIndex={activeIndex} setActiveIndex={setActiveIndex}  po={props.po} toast={props.toast} />}
            {activeIndex === 2 && <ClientInformation setNeedtoReload={setNeedtoReload} activeIndex={activeIndex} setActiveIndex={setActiveIndex} po={props.po} toast={props.toast} />}
            {activeIndex === 3 && <SubVendorInformation setNeedtoReload={setNeedtoReload} activeIndex={activeIndex} setActiveIndex={setActiveIndex} po={props.po} toast={props.toast} />}
            {activeIndex === 4 && <ProjectInformation setNeedtoReload={setNeedtoReload} activeIndex={activeIndex} setActiveIndex={setActiveIndex} po={props.po} toast={props.toast} />}
            {activeIndex === 5 && <IncentiveCalculation setNeedtoReload={setNeedtoReload} activeIndex={activeIndex} setActiveIndex={setActiveIndex} po={props.po} toast={props.toast} />}
            {/* {activeIndex === 6 && <BranchIncentiveCalculation po={props.po} toast={props.toast} />} */}
            <hr />
            <div className='flex flex-row-reverse gap-3 mt-5'>
                {activeIndex === 5 && <Button className='w-6rem' onClick={onHide} label='DONE'></Button>}
                {activeIndex < 5 && <Button className='w-5rem' onClick={() => setActiveIndex(activeIndex + 1)} label='NEXT'></Button>}
                {activeIndex > 0 && <Button className='w-7rem p-button-outlined' onClick={() => setActiveIndex(activeIndex - 1)} label='PREVIOUS'></Button>}
            </div>
        </Dialog>
    );
}